import { bufferSetupCompletedEvents } from "/Features/Forms/js/forms-setup-buffer.js";

// Subscribe synchronously, before the dynamic import below.
//
// EPiServer raises `formsSetupCompleted` once, synchronously, inside `$(document).ready()`
// (EPiServerForms.js:1682) using jQuery's `triggerHandler`, which only reaches listeners that
// are already attached. This module is loaded by a blocking <script> in the site bundle
// (_DefaultLayout.cshtml:34) that runs before DOMContentLoaded, so subscribing here is
// guaranteed to beat the event. Waiting for DOMContentLoaded first - as this loader used to -
// meant the event had already fired by the time the chunk subscribed, silently skipping
// setupCompleted() and leaving lead source and every other hidden metadata field blank.
bufferSetupCompletedEvents();

document.addEventListener("DOMContentLoaded", function () {
    const forms = document.querySelectorAll(".EPiServerForms");

    if (forms.length) {
        import(/* webpackChunkName: "optimizely-forms" */"/Features/Forms/js/optimizely-forms.js");
    }
});
